import { render, staticRenderFns } from "./AvatarPopup.vue?vue&type=template&id=79404a11"
import script from "./AvatarPopup.vue?vue&type=script&lang=js"
export * from "./AvatarPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports